module.exports = __webpack_public_path__ + "media/icons/pdx-4a271011.png";